import { render } from "./P2PForm.vue?vue&type=template&id=7fe0b4ba&scoped=true"
import script from "./P2PForm.vue?vue&type=script&lang=js"
export * from "./P2PForm.vue?vue&type=script&lang=js"

import "./P2PForm.vue?vue&type=style&index=0&id=7fe0b4ba&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fe0b4ba"]])

export default __exports__